import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-status-badge-renderer',
    template: `
    <span [ngClass]="badgeClass">{{ value }}</span>
  `,
    styles: [`
    .badges {
      padding: 4px 10px;
      border-radius: 12px;
      color: white;
      font-size: 12px;
    }
    .complete { background-color: rgb(54, 162, 235); }
    .failed { background-color: rgb(255, 99, 132); }
    .aborted { background-color: rgb(255, 205, 86); color: black; }
  `],
    standalone: false
})
export class StatusBadgeRendererComponent implements ICellRendererAngularComp {
  value: string = '';
  badgeClass: string = '';

  agInit(params: any): void {
    this.value = params.value;
    this.badgeClass = this.getBadgeClass(params.value);
  }

  refresh(): boolean {
    return false;
  }

  getBadgeClass(status: string): string {
    const base = 'badges ';
    switch (status?.toLowerCase()) {
      case 'complete': return base + 'complete';
      case 'failed': return base + 'failed';
      case 'aborted': return base + 'aborted';
      default: return base;
    }
  }
}
